import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/app/[locale]/(jupiter-frame)/(sportsbook)/(main)/live/[sport]/page.tsx");
